import React from "react";
import Modal from "../../../../../old/Portals/Modal/Modal";

import { ReactComponent as ExitIco } from "../../../../Assets/closeBig.svg";
import Button from "../../../../../old/Components/Atoms/Button";
import Colors from "src/general/constants/colors";
import * as ST from "./styled";

const ExitWindow = ({
	open,
	accept,
	handleClick,
}: {
	open: boolean;
	accept: () => void;
	handleClick: () => void;
}): JSX.Element => {
	return (
		<Modal
			open={open}
			marker={"modal-window-ExitWindow-1"}
			isFixed={true}
			zIndex={100000000}
		>
			<ST.Content>
				<ST.Close onClick={handleClick}>
					<ExitIco />
				</ST.Close>
				<ST.Title>Выйти из личного кабинета</ST.Title>

				<ST.WrapperButtons>
					<Button
						onClick={handleClick}
						color={Colors.PEOPLE_OLD}
						background={Colors.WHITE}
					>
						Нет
					</Button>
					<Button
						onClick={accept}
						background={Colors.PEOPLE_OLD}
						color={Colors.WHITE}
					>
						Да
					</Button>
				</ST.WrapperButtons>
			</ST.Content>
		</Modal>
	);
};

export default ExitWindow;
